<script setup>
/**
 * FormControlPortalSitesBuildName
 * Lightweight alias wrapper around the core URL slug configuration control.
 * Safely passes form props and reactive text change events straight through
 * to the underlying atomic routing input element.
 */
import FormControlUrlSlug from './FormControlUrlSlug.vue'

defineProps({
    // Standard Orchestrator Props passed through natively
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number],
        default: null
    }
})
</script>

<template>
    <FormControlUrlSlug v-bind="$props"/>
</template>